<h2 mat-dialog-title><mat-icon class="icon-20" >delete</mat-icon> Remove User: {{data.user.fullName}} ({{data.user.userName}})</h2>
<div mat-dialog-content>Are you sure?<br /><br /></div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="Yes" aria-label="Yes">Yes</button>
  <button mat-button mat-dialog-close="No" aria-label="No">No</button>
</div>